import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import BrowserOnly from 'components/consumer/BrowserOnly';
import ProductListingPageContext from 'data-hooks/context/ProductListingPageContext';
import ProductListingPageWidgets from 'components/consumer/ProductListingPageWidgets';
import ProductListingPageDescription from './components/ProductListingPageDescription';
import DesktopProductListingSidebarFilters from './components/desktop/DesktopProductListingSidebarFilters';
import ProductListingSortBy from './components/ProductListingSortBy';
import DesktopShowHideFiltersButton from './components/desktop/DesktopShowHideFiltersButton';
import ProductListingResultsCount from './components/ProductListingResultsCount';
import DesktopProductListingSidebarContainer from './components/desktop/DesktopProductListingSidebarContainer';
import ProductListingLoadMoreButtons from './components/ProductListingLoadMoreButtons';
import ProductListingGrid from './components/ProductListingGrid';
import ProductListingPageName from './components/ProductListingPageName';
import useProductListingAnalytics from './hooks/useProductListingAnalytics';
import ProductListingPageTitleAndMetaTags from './components/ProductListingPageTitleAndMetaTags';
import MobileGridColumnToggle from './components/mobile/MobileGridColumnToggle';
import MobileProductListingFiltersButtonAndModal from './components/mobile/MobileProductListingFiltersButtonAndModal';
import DesktopProductListingColorFilter from './components/desktop/DesktopProductListingColorFilter';
const ProductListingPage = t0 => {
  const $ = _c(53);
  const {
    pageData,
    pageHeaderOverride,
    sidebarHeader,
    variant
  } = t0;
  const [isDesktopSidebarOpen, setIsDesktopSidebarOpen] = useState(true);
  useProductListingAnalytics(pageData);
  const {
    loading,
    isFinalProductCountKnown,
    pageName,
    totalProductCount
  } = pageData;
  if (loading) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProductListingPageTitleAndMetaTags />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = variant === "advanced-search";
  const t3 = variant === "advanced-search";
  const t4 = !variant || variant !== "advanced-search";
  let t5;
  if ($[1] !== t3 || $[2] !== t4) {
    t5 = classNames("px-3 py-4 space-y-1", "md:px-0 md:py-0 md:space-y-0", "md:items-center md:bg-white md:flex md:h-[53px] md:sticky md:z-[11] md:gap-5 md:justify-between", {
      "md:top-[55px]": t3,
      "md:top-[117px]": t4
    });
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = variant === "advanced-search";
  let t7;
  if ($[4] !== loading || $[5] !== pageName || $[6] !== t6) {
    t7 = <ProductListingPageName loading={loading} pageName={pageName} showPageNameWhileLoading={t6} />;
    $[4] = loading;
    $[5] = pageName;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = loading || !isFinalProductCountKnown;
  let t9;
  if ($[8] !== t8 || $[9] !== totalProductCount || $[10] !== variant) {
    t9 = <ProductListingResultsCount loading={t8} totalProductCount={totalProductCount} variant={variant} />;
    $[8] = t8;
    $[9] = totalProductCount;
    $[10] = variant;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => {
      setIsDesktopSidebarOpen(_temp);
    };
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== loading) {
    t11 = <DesktopShowHideFiltersButton loading={loading} onClick={t10} />;
    $[13] = loading;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t7 || $[17] !== t9) {
    t12 = <div className="md:flex md:gap-5 md:items-center">{t7}{t9}{t11}</div>;
    $[15] = t11;
    $[16] = t7;
    $[17] = t9;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  let t14;
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = classNames("flex flex-row justify-between gap-3 py-3", "md:block md:gap-0 md:py-0");
    t14 = classNames("flex-1 flex gap-1", "md:flex-initial md:block md:gap-0");
    t15 = <MobileProductListingFiltersButtonAndModal />;
    $[19] = t13;
    $[20] = t14;
    $[21] = t15;
  } else {
    t13 = $[19];
    t14 = $[20];
    t15 = $[21];
  }
  let t16;
  if ($[22] !== pageHeaderOverride) {
    t16 = pageHeaderOverride ?? <><DesktopProductListingColorFilter /><ProductListingSortBy /></>;
    $[22] = pageHeaderOverride;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== t16) {
    t17 = <div className={t14}>{t15}<div className="flex-1 md:flex-initial md:flex md:flex-row md:gap-4 md:items-center">{t16}</div></div>;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <MobileGridColumnToggle />;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t17) {
    t19 = <div className={t13}>{t17}{t18}</div>;
    $[27] = t17;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t12 || $[30] !== t19 || $[31] !== t5) {
    t20 = <div className={t5}>{t12}{t19}</div>;
    $[29] = t12;
    $[30] = t19;
    $[31] = t5;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== variant) {
    t21 = <DesktopProductListingSidebarFilters variant={variant} />;
    $[33] = variant;
    $[34] = t21;
  } else {
    t21 = $[34];
  }
  let t22;
  if ($[35] !== isDesktopSidebarOpen || $[36] !== sidebarHeader || $[37] !== t21) {
    t22 = <div className="hidden md:block"><DesktopProductListingSidebarContainer isOpen={isDesktopSidebarOpen}>{sidebarHeader}{t21}</DesktopProductListingSidebarContainer></div>;
    $[35] = isDesktopSidebarOpen;
    $[36] = sidebarHeader;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <ProductListingGrid />;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <div className="md:space-y-8 md:mb-8 md:flex-1">{t23}<BrowserOnly><ProductListingLoadMoreButtons /></BrowserOnly><ProductListingPageDescription /></div>;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] !== t22) {
    t25 = <div className="md:flex md:flex-row md:gap md:mt-2">{t22}{t24}</div>;
    $[41] = t22;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  let t26;
  if ($[43] !== t2 || $[44] !== t20 || $[45] !== t25) {
    t26 = <FixedWidthContainer wide={true} noMobilePadding={true} noPadding={t2}>{t20}{t25}</FixedWidthContainer>;
    $[43] = t2;
    $[44] = t20;
    $[45] = t25;
    $[46] = t26;
  } else {
    t26 = $[46];
  }
  const t27 = pageData?.pageId;
  let t28;
  if ($[47] !== t27) {
    t28 = <ProductListingPageWidgets categoryId={t27} />;
    $[47] = t27;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== pageData || $[50] !== t26 || $[51] !== t28) {
    t29 = <ProductListingPageContext.Provider value={pageData}>{t1}{t26}{t28}</ProductListingPageContext.Provider>;
    $[49] = pageData;
    $[50] = t26;
    $[51] = t28;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  return t29;
};
ProductListingPage.propTypes = {
  pageData: PropTypes.shape({
    filters: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      options: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string
      }))
    })),
    filterStateKey: PropTypes.string,
    loading: PropTypes.bool,
    loadMoreClickCount: PropTypes.number,
    loadMoreProducts: PropTypes.func,
    isAllDataLoading: PropTypes.bool,
    isFinalProductCountKnown: PropTypes.bool,
    pageId: PropTypes.number,
    pageName: PropTypes.string,
    pageLongDescription: PropTypes.string,
    products: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      initialOptionId: PropTypes.string,
      name: PropTypes.string,
      onDisplayInShowroomSlug: PropTypes.string,
      path: PropTypes.string,
      productLabel: PropTypes.string,
      quickship: PropTypes.bool,
      secondaryImage: PropTypes.string,
      secondaryImageCropData: PropTypes.object,
      variants: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        image: PropTypes.string,
        minPrice: PropTypes.number,
        originalPrice: PropTypes.number,
        path: PropTypes.string.isRequired,
        price: PropTypes.number.isRequired,
        quickship: PropTypes.bool
      })),
      variantsTotal: PropTypes.number
    })),
    resetFilters: PropTypes.func,
    setSortOrder: PropTypes.func,
    showLoadMoreButton: PropTypes.bool,
    sortOrder: PropTypes.string,
    toggleFilter: PropTypes.func,
    toggleFilterOption: PropTypes.func,
    totalProductCount: PropTypes.number
  }),
  sidebarHeader: PropTypes.node,
  pageHeaderOverride: PropTypes.node,
  variant: PropTypes.oneOf(['advanced-search'])
};
export default ProductListingPage;
function _temp(prevIsOpen) {
  return !prevIsOpen;
}